export function initialFormData(data) {
  return {
    guests: [],
    company: {
      socialReason: {
        value: data.Attributes[2]?.Value || "",
        id: 590713,
      },
      socialMedia: {
        value: "",
        id: 590715,
      },
      fantasyName: {
        value: data.Attributes[3]?.Value || "",
        id: 590716,
      },
      cnpj: {
        value: data.Attributes[0]?.Value || "",
        id: 590717,
      },
      stateRegistration: {
        value: "",
        id: 590718,
      },
      municipalRegistration: {
        value: "",
        id: 590719,
      },
      cepCompany: {
        value: "",
        id: 594224,
      },
      address: {
        value: "",
        id: 590720,
      },
      cityCompany: {
        value: "",
        id: 590721,
      },
      pais: {
        value: "",
        id: 597514,
      },
      state: {
        value: "",
        id: 590722,
      },
      phone1: {
        value: "",
        id: 590723,
      },
      phone2: {
        value: "",
        id: 590724,
      },
      financialResponsible: {
        value: "",
        id: 590726,
      },
      email: {
        value: "",
        id: 590728,
      },
    },
  };
}

export const quantityGuest = {
  name: {
    value: "",
    id: 578390,
  },
  surname: {
    value: "",
    id: 590674,
  },
  badge: {
    value: "",
    id: 590675,
  },
  rg: {
    value: "",
    id: 590679,
  },
  cnpj: {
    value: "",
    id: 590717,
  },
  cpf: {
    value: "",
    id: 590677,
  },
  email: {
    value: "",
    id: 578391,
  },
  telephone: {
    value: "",
    id: 593869,
  },
  position: {
    value: "",
    id: 590678,
  },
  birth: {
    value: "",
    id: 590687,
  },
  gender: {
    value: "",
    id: 590688,
  },
  foodRestriction: {
    value: "",
    id: 594110,
  },
  whatRestriction: {
    value: "",
    id: 594111,
  },
  specificNeed: {
    value: "",
    id: 594113,
  },
  whatNeed: {
    value: "",
    id: 594114,
  },
  hasCompanion: {
    value: "",
    id: 590689,
  },
  needAir: {
    value: "",
    id: 590690,
  },
  upgrade: {
    value: "sim",
    id: 590707,
  },
  retailWomen: {
    value: "",
    id: 597513,
  },
  alteracaoApto: [
    {
      key: 1,
      id: 592817,
      hotel: "Royal Palm Plaza",
      label:
        "Pacote com hospedagem (quarto single) – R$ 3.600,00 (valor para uma pessoa)",
      value: 3600,
    },
    {
      key: 2,
      id: 592817,
      hotel: "Royal Palm Plaza",
      label:
        "Pacote com hospedagem (quarto duplo) – R$ 5.000,00 (valor para duas pessoas)",
      value: 5000,
    },
    {
      key: 3,
      id: 592817,
      hotel: "Royal Palm Plaza",
      label:
        "Pacote com hospedagem (quarto triplo) – R$ 6.400,00 (valor para três pessoas)",
      value: 6400,
    },
    {
      key: 4,
      id: 592817,
      hotel: "Royal Palm Plaza",
      label: "Sem hospedagem – 1.º lote – R$ 1.300,00",
      value: 1300,
    },
  ],
  tower_anhanguera: [
    {
      key: 5,
      id: 592817,
      hotel: "ROYAL PALM TOWER ANHANGUERA",
      label:
        "Pacote com hospedagem (quarto single) – R$ 2.600,00 (valor para uma pessoa)",
      value: 2600,
    },
    {
      key: 6,
      id: 592817,
      hotel: "ROYAL PALM TOWER ANHANGUERA",
      label:
        "Pacote com hospedagem (quarto duplo) – R$ 4.000,00 (valor para duas pessoas)",
      value: 4000,
    },
  ],
  companion: {
    nameCompanion: {
      value: "",
      id: 578390,
    },
    badgeCompanion: {
      value: "",
      id: 590675,
    },
    rgCompanion: {
      value: "",
      id: 590679,
    },
    birthCompanion: {
      value: "",
      id: 590687,
    },
    genderCompanion: {
      value: "",
      id: 590688,
    },
    emailCompanion: {
      value: "",
      id: 578391,
    },
    cnpjCompanion: {
      value: "",
      id: 590717,
    },
    cpfCompanion: {
      value: "",
      id: 590677,
    },
    positionCompanion: {
      value: "",
      id: 590678,
    },
    retailWomenCompanion: {
      value: "",
      id: 597513,
    },
  },
  flight: {
    departureAirport: {
      value: "",
      id: 590691,
    }, // Aeroporto de partida
    departureCIA: {
      value: "",
      id: 590692,
    }, // CIA
    departureLocator: {
      value: "",
      id: 590693,
    }, // Localizador
    departureDate: {
      value: "",
      id: 590694,
    }, // Data de partida
    departureTime: {
      value: "",
      id: 590695,
    }, // Hora de partida
    arrivalAirport: {
      value: "",
      id: 590696,
    }, // Aeroporto de chegada
    arrivalDate: {
      value: "",
      id: 590697,
    }, // Data de chegada
    returnDepartureAirport: {
      value: "",
      id: 590700,
    }, // Aeroporto de partida
    returnCIA: {
      value: "",
      id: 590701,
    }, // CIA
    returnLocator: {
      value: "",
      id: 590702,
    }, // Localizador
    returnDepartureDate: {
      value: "",
      id: 590703,
    }, // Data de partida
    returnDepartureTime: {
      value: "",
      id: 590704,
    }, // Hora de partida
    returnArrivalAirport: {
      value: "",
      id: 590705,
    }, // Aeroporto de chegada
    returnArrivalDate: {
      value: "",
      id: 590706,
    }, // Data de chegada
  },
};

export const states = [
  { nome: "Acre", sigla: "AC" },
  { nome: "Alagoas", sigla: "AL" },
  { nome: "Amapá", sigla: "AP" },
  { nome: "Amazonas", sigla: "AM" },
  { nome: "Bahia", sigla: "BA" },
  { nome: "Ceará", sigla: "CE" },
  { nome: "Distrito Federal", sigla: "DF" },
  { nome: "Espírito Santo", sigla: "ES" },
  { nome: "Goiás", sigla: "GO" },
  { nome: "Maranhão", sigla: "MA" },
  { nome: "Mato Grosso", sigla: "MT" },
  { nome: "Mato Grosso do Sul", sigla: "MS" },
  { nome: "Minas Gerais", sigla: "MG" },
  { nome: "Pará", sigla: "PA" },
  { nome: "Paraíba", sigla: "PB" },
  { nome: "Paraná", sigla: "PR" },
  { nome: "Pernambuco", sigla: "PE" },
  { nome: "Piauí", sigla: "PI" },
  { nome: "Rio de Janeiro", sigla: "RJ" },
  { nome: "Rio Grande do Norte", sigla: "RN" },
  { nome: "Rio Grande do Sul", sigla: "RS" },
  { nome: "Rondônia", sigla: "RO" },
  { nome: "Roraima", sigla: "RR" },
  { nome: "Santa Catarina", sigla: "SC" },
  { nome: "São Paulo", sigla: "SP" },
  { nome: "Sergipe", sigla: "SE" },
  { nome: "Tocantins", sigla: "TO" },
];
